import { guideSteps } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function BeginnerGuide() {
  return (
    <section id="guide" className="border-y border-accent-100 bg-accent-50">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          eyebrow="新手指南"
          title="第一次选模型手办？跟着这四步走"
          desc="不用一上来就研究门道，按顺序把预算、厂商、评分和实物反馈过一遍，基本不会踩坑。"
        />

        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
          {guideSteps.map((step, index) => (
            <div
              key={step.id}
              className="relative rounded-lg border border-accent-200 bg-background-50 p-5"
            >
              <div className="flex items-center justify-between">
                <span className="font-heading text-3xl font-bold text-accent-400">{step.step}</span>
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                  <i
                    className={
                      ["ri-wallet-3-line", "ri-store-2-line", "ri-bar-chart-box-line", "ri-chat-smile-2-line"][
                        index
                      ]
                    }
                  />
                </span>
              </div>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">
                {step.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{step.desc}</p>
              {index < guideSteps.length - 1 && (
                <i className="ri-arrow-right-line absolute -right-2.5 top-1/2 hidden -translate-y-1/2 text-accent-400 lg:block" />
              )}
            </div>
          ))}
        </div>

        <div className="mt-6 flex flex-col gap-3 rounded-lg border border-accent-200 bg-background-50 p-5 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-sm leading-relaxed text-foreground-700">
            <i className="ri-lightbulb-line mr-2 text-accent-600" />
            还没想好买哪款？先把预算和喜欢的角色发到论坛，热心的同好会给你列清单。
          </p>
          <a
            href="#forum"
            className="flex shrink-0 items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-accent-600"
          >
            去论坛求推荐
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}